// extracted by mini-css-extract-plugin
module.exports = {"layout":"e_sb","storyTitle":"e_tb","arrowLink":"e_ub","arrowIcon":"e_vb"};